var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentNormal2 = function SvgCommentNormal2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "commentNormal2_svg__prefix__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#commentNormal2_svg__prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.438 4.5a1.5 1.5 0 011.5-1.5h10.124a1.5 1.5 0 011.5 1.5v7.313a1.5 1.5 0 01-1.5 1.5h-3.45a.374.374 0 00-.205.06l-3.078 2a.375.375 0 01-.579-.314v-1.746H3.937a1.5 1.5 0 01-1.5-1.5V4.5z",
    stroke: "#39404D",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 8.063,
    r: 0.938,
    fill: "#39404D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8.063,
    r: 0.938,
    fill: "#39404D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.063,
    r: 0.938,
    fill: "#39404D"
  }))));
};
export default SvgCommentNormal2;